import { CompactAddressModel } from './compactAddressModel.model';
import { ContactAddressModel } from './contactAddressModel.model';

export class ContactModel {
    id: number;
    Type: string;

    contactTypeFlag: string;
    preferredChannel: string;
    email: string;

    salutation: string;
    businessName: string;
    businessName2: string;
    fein: string;
    deceasedDate: Date;
    firstName: string;
    middleName: string;
    lastName: string;
    fullName: string;
    nameSuffix: string;
    title: string;

    genderIdentity: string;
    ethnicity: string;

    socialSecurityNumber: string;
    stateIdNumber: string;
    passportNumber: string;

    tradeName: string;

    countryCode: string;
    phone1: string;
    phone2: string;
    phone3: string;
    fax: string;

    addressLine1: string;
    addressLine2: string;
    addressLine3: string;

    birthCity: string;
    birthDate: Date;
    birthState: string;
    birthRegion: string;

    driverLicenseNbr: string;
    driverLicenseState: string;

    postOfficeBox: string;

    comment: string;
    contactSeqNumber: string;
    primaryAddressFlag: boolean;
    auditStatus: string;

    zip: string;

    rowIndex: number;

    Addresses: ContactAddressModel[] = new Array<ContactAddressModel>();
    CompactAddress: CompactAddressModel = new CompactAddressModel();
}
